'use strict';

const customchosen = (function() {
    var hookCallback;

    function utils_hooks__hooks() {
        return hookCallback.apply(null, arguments);
    }

    function chosen($el) {
        if (typeof $el !== "undefined" && browser_is_supported()) {
            $el.chosen({no_results_text: "Oops, nothing found!", width: '100%'}).addClass("replaced");
        }
    }

    function browser_is_supported() {
        if ("Microsoft Internet Explorer" === window.navigator.appName) {
            return document.documentMode >= 8;
        }
        if (/iP(od|hone|pad)/i.test(window.navigator.userAgent) || /IEMobile/i.test(window.navigator.userAgent) || /Windows Phone/i.test(window.navigator.userAgent) || /BlackBerry/i.test(window.navigator.userAgent) || /BB10/i.test(window.navigator.userAgent) || /Android.*Mobile/i.test(window.navigator.userAgent)) {
            return false;
        }
        return true;
    }

    utils_hooks__hooks.version = '1.0.0';
    utils_hooks__hooks.chosen = chosen;
    utils_hooks__hooks.browser_is_supported = browser_is_supported;

    return utils_hooks__hooks;
})();

export default customchosen;
